import { defineComponent as _defineComponent } from 'vue'
import { computed, useRoute } from '@nuxtjs/composition-api'


export default /*#__PURE__*/_defineComponent({
  __name: 'NavLink',
  props: {
    href: null,
    icon: null,
    name: null,
    disabled: { type: Boolean },
    noHighlight: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  href: string | { path: string; query: any }
  icon?: any
  name: TranslateResult
  disabled?: boolean
  noHighlight?: boolean
};



const route = useRoute()
const current = computed(
  () =>
    !props.noHighlight &&
    route.value.path.endsWith(typeof props.href === 'string' ? props.href : props.href.path)
)

// TODO sometimes this breaks down and always returns '/'. have to solve why
const localeHref = computed(() => props.href)

return { __sfc: true,props, route, current, localeHref }
}

})